function Protected() {
  return <h1>Protected Page</h1>;
}

export default Protected;
